/** Keep storage terminology out of customer-facing approval errors. */
export function publicationError(message) {
  if (!message) return message;
  if (/^(?:Sandbox|Branch) publication failed\.?$/i.test(message)) {
    return 'Changes could not be applied. Your approval is saved. Some changes may already be live.';
  }
  if (/^(?:OS Branch|Sandbox) is approval_pending and cannot be archived\.?$/i.test(message)) {
    return 'This proposal is awaiting approval and could not be discarded.';
  }
  return String(message)
    .replace(/\b(?:OS )?(?:branch|sandbox)\b/gi, 'proposal')
    .replace(/\b(?:OS )?revision\b/gi, 'draft')
    .replace(/\bcontent hash\b/gi, 'contents')
    .replace(/\bapproval_pending\b/g, 'awaiting approval');
}
